import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { DatePicker, Form, Input, Space, Typography } from 'antd';
import { PDNDForeignCountryLoadableInput } from 'client/components/schema/integrations/pdnd/input/PDNDForeignCountryLoadableInput';
import { PDNDMunicipalityLoadableInput } from 'client/components/schema/integrations/pdnd/input/PDNDMunicipalityLoadableInput';
import { FormikForm } from 'client/ui/form/FormikForm';
import { FormItemLayout } from 'client/ui/form/FormItem';
import { CheckboxInputItem } from 'client/ui/form/input/CheckboxInputItem';
import { DatePickerInputItem } from 'client/ui/form/input/DatePickerInputItem';
import { RadioInputItem } from 'client/ui/form/input/RadioInputItem';
import { TextInputItem } from 'client/ui/form/input/TextInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import {
  IPDNDVerificationRequest,
  PDNDVerificationLocationType
} from 'common/dto/PDNDVerificationDto';
import React from 'react';
import { useTranslation } from 'react-i18next';

const tailLayout = {
  wrapperCol: { sm: { offset: 6, span: 12 }, xs: { offset: 0, span: 24 } }
};

interface IPDNDPersonalDetailsFormProps {
  layout: FormItemLayout;
  values?: IPDNDVerificationRequest;
}

export function PDNDPersonalDetailsForm(props: IPDNDPersonalDetailsFormProps) {
  const { layout, values } = props;
  const { t } = useTranslation();
  return (
    <>
      <FormDividerSpace
        title={t(
          'verification.c020.form.citizenRegistry',
          'Ricerca per Anagrafica del Cittadino'
        )}
        layout={layout}
        style={{ marginTop: 0 }}
      />
      <TextInputItem
        label={t('verification.c020.form.citizenRegistry.label.nome', 'Nome')}
        name="search.registry.nome"
      />
      <TextInputItem
        label={t(
          'verification.c020.form.citizenRegistry.label.cognome',
          'Cognome'
        )}
        name="search.registry.cognome"
      />

      <DatePickerInputItem
        label={t(
          'verification.c020.form.citizenRegistry.label.datiNascita.dataEvento',
          'Data di Nascita'
        )}
        name="search.registry.datiNascita.dataEvento"
        type={'from'}
        style={{ width: '100%' }}
      />
      <RadioInputItem
        name="search.registry.datiNascita.luogoNascita.locationType"
        label="Tipo Luogo Nascita"
        options={[
          {
            value: PDNDVerificationLocationType.Italian,
            label: 'Comune Italiano'
          },
          { value: PDNDVerificationLocationType.Foreign, label: 'Stato Estero' }
        ]}
      />

      {values?.search?.registry?.datiNascita?.luogoNascita?.locationType ===
        PDNDVerificationLocationType.Italian && (
        <>
          <PDNDMunicipalityLoadableInput />
        </>
      )}
      {values?.search?.registry?.datiNascita?.luogoNascita?.locationType ===
        PDNDVerificationLocationType.Foreign && (
        <>
          <PDNDForeignCountryLoadableInput />
        </>
      )}

      <RadioInputItem
        name="search.registry.sesso"
        label="Sesso"
        options={[
          { value: 'M', label: 'Maschile' },
          { value: 'F', label: 'Femminile' }
        ]}
      />

      {/* Lista Checkbox per le Eccezioni */}
      <Form.Item label="Eccezioni">
        <FormikForm nested helpInTooltips>
          <div>
            <Space size="large">
              <CheckboxInputItem
                style={{ paddingRight: '22px' }}
                name="search.registry.senzaCognome"
                value={'S'}
                title="Senza Cognome"
              />
              <CheckboxInputItem
                style={{ paddingRight: '22px' }}
                name="search.registry.senzaNome"
                value={'S'}
                title="Senza Nome"
              />
            </Space>
          </div>
          <div>
            <Space size="large">
              <CheckboxInputItem
                style={{ paddingRight: '22px' }}
                name="search.registry.datiNascita.senzaGiorno"
                value={'S'}
                title="Senza Giorno Nascita"
              />
              <CheckboxInputItem
                style={{ paddingRight: '22px' }}
                name="search.registry.datiNascita.senzaGiornoMese"
                value={'S'}
                title="Senza Giorno e Mese Nascita"
              />
            </Space>

            {(values?.search?.registry?.datiNascita?.senzaGiorno ||
              values?.search?.registry?.datiNascita?.senzaGiornoMese) && (
              <Typography.Text type="secondary">
                Inserire comunque la data di nascita nel formato GG/MM/YYYY,
                utilizzando "01" laddove il dato non sia noto. Ad esempio,
                01/01/2000 per un Cittadino nato nell'anno 2000 senza giorno e
                mese.
              </Typography.Text>
            )}
          </div>
          {/* <div>
            <Space size="large">
              <CheckboxInputItem
                style={{ paddingRight: '22px' }}
                name="search.registry.datiNascita.luogoNascita.luogoEccezionale"
                value={'S'}
                title="Luogo Nascita eccezionale"
              />
            </Space>
          </div> */}
        </FormikForm>
      </Form.Item>
    </>
  );
}
